export default {
  state: {
    server: "https://apicl.webproject.fyi:8080/",
    token: "",
  },
  mutations: {
    createTokens(state, tokens) {
      state.token = tokens.token;
      state.refresh_token = tokens.refresh_token;
    },
    saveLocalToken(state, tokens) {
      localStorage.setItem("t", tokens.token);
      localStorage.setItem("rt", tokens.refresh_token);
    },
  },
  getters: {
    server: s => s.server
  },
  actions: {
    logout({commit}) {
      localStorage.clear();
      commit("clearInfo");
      commit("removeToken");
    },
    async login({state, commit}, {login, password}) {
      let res = {};
      await fetch(state.server + "api/login_check", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username: login,
          password: password
        }) // тип данных в body должен соответвовать значению заголовка "Content-Type"
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.token) {
            commit("createTokens", {
              token: response.token,
              refresh_token: response.refresh_token
            });
            commit("saveLocalToken", {
              token: response.token,
              refresh_token: response.refresh_token
            });
            res.login = true;
          } else {
            res.login = false;
            res.message = response.message;
          }
        });
      return res;
    },
    async register({state}, obj) {
      let res;
      await fetch(state.server + "admin/users/creates", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + state.token
        },
        body: JSON.stringify(obj)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          // res = {
          //   id: response.id,
          //   email: response.email
          // };
          res = response
        });
      return res;
    },
    async request({state}, {path, body}) {
      let res;
      await fetch(state.server + path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + state.token
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          res = response;
        });
      return res;
    }
  },
  modules: {}
};
